/*
 * Nordicsell - sidanpassad erbjudandepanel.
 *
 * layout/theme.liquid skriver ut <meta name="ns-page-deal" content="...">
 * med en nyckel för sidan kunden står på (se snippets/ns-page-deal.liquid).
 * Det här skriptet letar upp motsvarande rad i panelen "Aktuella erbjudanden",
 * flyttar den högst upp och märker den "Gäller den här sidan".
 *
 * Raderna matchas på ord i rubriken, inte på block-id, så att panelen kan
 * redigeras i temaredigeraren utan att det här slutar fungera. Byter du
 * rubriktext - uppdatera orden nedan. Hittas ingen rad händer ingenting och
 * panelen visas som vanligt.
 */
(function () {
  var ORD = {
    klader: ['klänning', 'träningskläd'],
    smycken: ['smycke'],
    husdjur: ['husdjur'],
    pod: ['personlig', 'gravyr'],
    varumarken: ['varumärk']
  };
  var BADGE = 'Gäller den här sidan';

  function nyckel() {
    var m = document.querySelector('meta[name="ns-page-deal"]');
    return m ? (m.getAttribute('content') || '').trim() : '';
  }

  function markera() {
    var key = nyckel();
    if (!key || !ORD[key]) return;

    var listor = document.querySelectorAll('.spotlight__list');
    if (!listor.length) return;

    Array.prototype.forEach.call(listor, function (lista) {
      var rader = lista.querySelectorAll('.spotlight__item');
      var traff = null;

      Array.prototype.forEach.call(rader, function (rad) {
        if (traff) return;
        var rubrik = rad.querySelector('.spotlight__item-heading');
        if (!rubrik) return;
        var text = (rubrik.textContent || '').toLowerCase();
        for (var i = 0; i < ORD[key].length; i++) {
          if (text.indexOf(ORD[key][i]) !== -1) {
            traff = rad;
            return;
          }
        }
      });

      if (!traff || traff.dataset.nsCurrent === '1') return;
      traff.dataset.nsCurrent = '1';
      traff.classList.add('spotlight__item--current');

      var rubrik = traff.querySelector('.spotlight__item-heading');
      if (rubrik && !traff.querySelector('.ns-deal-badge')) {
        var b = document.createElement('span');
        b.className = 'ns-deal-badge';
        b.textContent = BADGE;
        rubrik.insertAdjacentElement('afterend', b);
      }

      if (lista.firstElementChild !== traff) {
        lista.insertBefore(traff, lista.firstElementChild);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', markera);
  } else {
    markera();
  }
  document.addEventListener('shopify:section:load', markera);
})();
